import { AppThunk } from '../store';
import { nextQuestion } from '../store/questionnaireAnswerSlice';
import { questionnaireNavigation } from '../../utils/locations';
import { Location, NavigateFunction } from 'react-router-dom';

export const goToNextQuestion = ({
  location,
  navigate,
}: {
  location: Location;
  navigate: NavigateFunction;
}): AppThunk => (dispatch, getState) => {
  dispatch(nextQuestion());

  const state = getState();

  const {
    question,
    survey,
    domain,
    topic,
    bestPractice,
  } = {
    question: state.questionnaireAnswer.question,
    survey: state.surveys.survey,
    domain: state.questionnaireAnswer.domain,
    topic: state.questionnaireAnswer.topic,
    bestPractice: state.questionnaireAnswer.bestPractice,
  };

  const assessment = state.assessments.assessment;

  if (!question || !survey || !domain || !topic || !bestPractice) return;

  questionnaireNavigation(
    location,
    navigate,
    survey,
    domain,
    topic,
    bestPractice,
    question,
    assessment,
  );
};